import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { newsArticles } from "../data/newsData"; // Importa os dados
import Header from "../../../shared/components/common/Header"; // Importe seu Header
import Footer from "../../../shared/components/common/Footer"; // Importe seu Footer
import ContactDrawer from "../../../shared/components/common/ContactDrawer";

const ArticlePage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  // Encontrar o artigo
  const article = newsArticles.find((art) => art.id === id);

  // Redirecionamento 404
  useEffect(() => {
    // Rola para o topo da página ao carregar um novo artigo
    window.scrollTo(0, 0);
    if (!article) {
      navigate("/404");
    }
  }, [article, navigate]);

  if (!article) {
    return null; // Retorna null enquanto redireciona
  }

  // FUNÇÃO DE FORMATAÇÃO REVISADA PARA GARANTIR QUE TODO O TEXTO APAREÇA
  const formatDescription = (text) => {
    // 1. Substitui **texto** por <strong>texto</strong> (Negrito)
    let formattedText = text.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");

    // 2. Divide o texto em todas as linhas lógicas (incluindo quebras de linha simples)
    const lines = formattedText.split(/[\r\n]+/).filter(line => line.trim() !== '');

    let html = '';
    let inList = false;

    lines.forEach(line => {
      const trimmedLine = line.trim();

      // Checa se é um item de lista (começa com * ou -)
      if (trimmedLine.startsWith('* ') || trimmedLine.startsWith('- ')) {
        if (!inList) {
          html += '<ul>'; // Inicia a lista
          inList = true;
        }
        // Adiciona o item da lista
        // Remove o prefixo da lista (* ou -) antes de adicionar
        html += `<li>${trimmedLine.substring(2).trim()}</li>`;
      } else {
        if (inList) {
          html += '</ul>'; // Fecha a lista anterior
          inList = false;
        }
        // Adiciona um parágrafo para todo bloco de texto que não é lista
        html += `<p>${trimmedLine}</p>`;
      }
    });

    // Fecha a lista se ela estiver aberta no final
    if (inList) {
      html += '</ul>';
    }

    return <div dangerouslySetInnerHTML={{ __html: html }} />;
  };
  // FIM DA FUNÇÃO DE FORMATAÇÃO

  return (
    <div className="bg-[#f3f6f8]">
      <Header /> {/* Seu Header */}

      {/* SEÇÃO PRINCIPAL - Estilo Hero Banner */}
      <section
        className="relative min-h-[50vh] flex items-end justify-center px-4 pt-24 pb-12"
        style={{
          backgroundImage: `url(${article.image})`, // Imagem do artigo como fundo
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* Card do Conteúdo Principal - Estilo do seu HeroCard da Home */}
        <div className="w-full max-w-5xl bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl p-8 pointer-events-auto">
          <div className="text-center">
            {/* Tipo de Notícia (em um badge para destaque) */}
            <span className="inline-block bg-black text-white text-xs font-semibold px-3 py-1 rounded-full uppercase tracking-wider mb-3">
              {article.type}
            </span>

            {/* Título */}
            <p className="text-4xl sm:text-5xl font-extrabold text-gray-900 mb-4 leading-tight">
              {article.title}
            </p>

            {/* Metadados */}
            <p className="text-sm text-gray-600">
              Publicado em: <strong>{article.date}</strong>
            </p>
          </div>
        </div>
      </section>

      {/* SEÇÃO DO CONTEÚDO DO ARTIGO */}
      <div className="container mx-auto px-4 py-12 max-w-5xl">
        <div className="bg-white rounded-2xl shadow-lg p-6 sm:p-10">
          <div className="text-lg text-gray-700 leading-relaxed article-content">
            {/* CHAMA A FUNÇÃO DE FORMATAÇÃO CORRIGIDA */}
            {formatDescription(article.description)}
          </div>

          <hr className="my-10 border-gray-200" />

          {/* Botão de Voltar para a Home/Blog */}
          <div className="text-center">
            <button
              onClick={() => navigate(-1)}
              className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-full shadow-md text-white bg-black hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black transition-colors duration-300"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 mr-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M10 19l-7-7m0 0l7-7m-7 7h18"
                />
              </svg>
              Voltar para o Blog
            </button>
          </div>
        </div>
      </div>

      <Footer />
      <ContactDrawer
        message="Vim do site"
      />
    </div>
  );
};

export default ArticlePage;